import { Trophy, Award, Users, Target, Heart } from "lucide-react";

const STATS = [
  { value: "19", label: "National Champions" },
  { value: "20+", label: "Years of Experience" },
  { value: "100+", label: "College Placements" },
  { value: "2", label: "Locations" },
];

const VALUES = [
  { icon: Heart, title: "Love of the Game", desc: "We want everyone to experience the joy and benefits of playing squash." },
  { icon: Users, title: "Inclusivity", desc: "Squash is for everyone. We welcome players of all backgrounds, ages, and abilities." },
  { icon: Award, title: "Excellence", desc: "From beginners to champions, we pursue the highest standards in coaching and development." },
  { icon: Target, title: "Community", desc: "We build lasting relationships and foster a supportive squash community." },
];

const HISTORY = [
  { year: "2002", title: "LRG Squash Founded", desc: "Started as Dreadsports Squash and Fitness, coaching and mentoring young squash athletes with a focus on competitive development." },
  { year: "2017", title: "New Jersey Squash Club", desc: "Established the New Jersey Squash Club in Princeton, expanding our reach and developing international coaching partnerships." },
  { year: "2020", title: "CollegeSquashCamps Launched", desc: "Founded CollegeSquashCamps to connect promising students with top college coaches, resulting in placements at Harvard, Yale, Princeton, Stanford, and more." },
  { year: "2025", title: "LRG Squash — One Brand", desc: "Unified Baltimore and Princeton under LRG Squash with a shared mission: getting more people to love the game." },
];

const SectionHeading = ({ overline, title }) => (
  <div className="text-center mb-12">
    <span className="overline mb-2 block">{overline}</span>
    <h2 className="font-display text-3xl md:text-4xl font-bold text-[#F2EDE4]">{title}</h2>
  </div>
);

export const AboutMission = ({ mission }) => (
  <section className="section" style={{ background: "var(--lrg-surface)" }} data-testid="about-mission">
    <div className="container-custom grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <span className="overline mb-4 block">Our Mission</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-[#F2EDE4] mb-6">Growing the Love of Squash</h2>
        <p className="text-[#F2EDE4]/40 mb-6">{mission}</p>
        <div className="grid grid-cols-2 gap-6">
          {STATS.map((s) => (
            <div key={s.label}>
              <p className="font-display text-4xl font-bold text-[#F2EDE4]">{s.value}</p>
              <p className="text-[#F2EDE4]/40 text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="aspect-[4/3] rounded-sm overflow-hidden">
        <img src="https://customer-assets-agu9un31.emergentagent.net/job_squash-nexus/artifacts/y3yxbgr0_image.webp" alt="LRG Squash players" className="w-full h-full object-cover" />
      </div>
    </div>
  </section>
);

export const DirectorProfile = ({ director }) => (
  <section className="section" style={{ background: "var(--lrg-bg)" }} data-testid="about-director">
    <div className="container-custom max-w-4xl">
      <SectionHeading overline="Leadership" title="Meet Our Founder" />
      <div className="lrg-card">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div>
            <h3 className="font-display text-xl font-bold text-[#F2EDE4]">{director.name}</h3>
            <p className="text-[#0D6B56] font-semibold text-sm">{director.title}</p>
          </div>
          <div className="md:col-span-2">
            <p className="text-[#F2EDE4]/40 mb-6">{director.bio}</p>
            <h4 className="font-display text-lg font-bold text-[#F2EDE4] mb-4">Key Achievements</h4>
            <div className="grid sm:grid-cols-2 gap-3">
              {director.achievements?.map((a) => (
                <div key={a} className="flex items-start gap-2">
                  <Trophy className="w-4 h-4 text-[#0D6B56] mt-1 flex-shrink-0" />
                  <span className="text-sm text-[#F2EDE4]/40">{a}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export const AboutValues = () => (
  <section className="section" style={{ background: "var(--lrg-surface)" }} data-testid="about-values">
    <div className="container-custom">
      <SectionHeading overline="Our Values" title="What We Stand For" />
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {VALUES.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="lrg-card text-center">
            <Icon className="w-6 h-6 text-[#0D6B56] mx-auto mb-4" />
            <h3 className="font-display text-lg font-bold text-[#F2EDE4] mb-2">{title}</h3>
            <p className="text-[#F2EDE4]/40 text-sm">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const AboutHistory = () => (
  <section className="section" style={{ background: "var(--lrg-bg)" }} data-testid="about-history">
    <div className="container-custom max-w-3xl">
      <SectionHeading overline="Our Journey" title="Our History" />
      <div className="space-y-8">
        {HISTORY.map((h) => (
          <div key={h.year} className="flex gap-4">
            <div className="w-24 flex-shrink-0 text-right"><span className="font-display text-xl font-bold text-[#F2EDE4]">{h.year}</span></div>
            <div className="w-px bg-[#1D1F21] relative"><div className="absolute top-1 -left-1.5 w-3 h-3 bg-[#0D6B56] rounded-full"></div></div>
            <div className="pb-8">
              <h3 className="font-display text-lg font-bold text-[#F2EDE4] mb-2">{h.title}</h3>
              <p className="text-[#F2EDE4]/40">{h.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
